<template>
    <div>
        <img :src="takeOffAsset" alt="Take off/land" @click="onClickOpenTakeOffWidget" />
        <v-dialog
          content-class="take-off-dialog"
          data-app
          v-model="takeOffDialog"
          persistent
          max-width="500px"
        >
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
                <v-icon
                    large
                    left
                  >
                    {{ icon }}
                  </v-icon>
                <span class="text-h6 font-weight-light">{{ dialogTitle }}</span>
            </v-card-title>

            <v-card-text>
                {{ dialogText }}
            </v-card-text>
            <slide-unlock
                id="takeoffunlock"
                ref="takeoffunlock"
                :auto-width="true"
                :circle="true"
                :disabled="false"
                :noanimate="false"
                :height="40"
                :text="unlockText"
                :success-text="unlockSuccessText"
                @completed="onSliderComplete"
            />
            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                text
                @click="onCancelTakeOffWidget"
              >
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </div>
</template>

<script>
  import {configStatusSubject, sendViewerMessage} from "../webRtcViewer";
  import SlideUnlock from "vue2-slide-unlock"

  export default {
    name: "TakeOffWidget",
    components: {
      SlideUnlock
    },
    data: () => ({
      takeOffDialog: false,
    }),
    created () {
        // subscribe to config status subject
      this.subscription = configStatusSubject.subscribe({
        next: (configStatus) => {
          // update config status
          if (Object.prototype.hasOwnProperty.call(configStatus, 'takeOffWidget')) {
            if (Object.prototype.hasOwnProperty.call(configStatus.takeOffWidget, 'takeOffLandingState')) {
              this.$store.commit("setTakeOffLandingState", configStatus.takeOffWidget.takeOffLandingState);
            }
            if (Object.prototype.hasOwnProperty.call(configStatus.takeOffWidget, 'takeOffStartSucceeded')) {
              // todo: show message to user about taking off
            }
            if (Object.prototype.hasOwnProperty.call(configStatus.takeOffWidget, 'takeOffStartFailed')) {
              // todo: show message to user about failing to take off
            }
            // todo: handle RETURNING_TO_HOME, TAKE_OFF_DISABLED, LAND_DISABLED
          }
        }
      })
    },
    beforeDestroy() {
      this.subscription.unsubscribe()
    },
    computed: {
      takeOffAsset: function () {
        if (this.$store.getters.isLanding) {
          return require(`../assets/cancel_takeoff_enabled.svg`)
        } else if (this.$store.state.takeOffWidget.takeOffLandingState === 'FORCED_AUTO_LANDING') {
          return require(`../assets/cancel_takeoff_disabled.svg`)
        } else {
          let takeOffAssetImg = this.$store.getters.isFlying ? "land.svg" : "takeoff.svg"
          return require(`../assets/${takeOffAssetImg}`)
        }
      },
      icon: function () {
        return (this.$store.getters.isFlying ? `$vuetify.icons.land` : `$vuetify.icons.takeoff`)
      },
      dialogTitle: function () {
        if (this.$store.getters.isFlying) {
          return "Land?"
        } else if (this.$store.state.takeOffWidget.takeOffLandingState === 'WAITING_FOR_LANDING_CONFIRMATION') {
          return "Continue Landing?"
        } else if (this.$store.state.takeOffWidget.takeOffLandingState === 'UNSAFE_TO_LAND') {
          return "Not suitable for landing."
        } else {
          return "Take Off?"
        }
      },
      dialogText: function () {
        if (this.$store.getters.isFlying) {
          return "Aircraft will land at its current location. Check landing area is clear."
        } else if (this.$store.state.takeOffWidget.takeOffLandingState === 'WAITING_FOR_LANDING_CONFIRMATION') {
          // todo: 0.5m hardcoded?
          return "Aircraft has descended to 0.5m."
        } else if (this.$store.state.takeOffWidget.takeOffLandingState === 'UNSAFE_TO_LAND') {
          return "Area is not suitable for landing. Please move to a safer location."
        } else {
          // todo: 1.2m hardcoded?
          return "Ensure that conditions are safe for takeoff. Aircraft will go to an altitude of 1.2m and hover."
        }
      },
      unlockText: function () {
        if (this.$store.getters.isFlying) {
          return "Slide to Land"
        } else if (this.$store.getters.isLanding) {
          return "Slide to Land"
        } else if (this.$store.state.takeOffWidget.takeOffLandingState === 'UNSAFE_TO_LAND') {
          return "Slide to Force Landing"
        } else {
          return "Slide to Take Off"
        }
      },
      unlockSuccessText: function () {
        if (this.$store.getters.isFlying) {
          return "Landing"
        } else if (this.$store.getters.isLanding) {
          return "Landing"
        } else {
          return "Taking Off"
        }
      }
    },
    watch: {
      '$store.state.takeOffWidget.takeOffLandingState': function(newState) {
        if (newState === 'WAITING_FOR_LANDING_CONFIRMATION') {
          this.takeOffDialog = true;
        }
      }
    },
    methods: {
      onClickOpenTakeOffWidget: function () {
        // don't do anything
        if (this.$store.state.takeOffWidget.takeOffLandingState === 'FORCED_AUTO_LANDING') {
          return;
        } else if (this.$store.state.takeOffWidget.takeOffLandingState === 'AUTO_LANDING') {
          sendViewerMessage(JSON.stringify({ cancelLand: true }))
        } else {
          this.takeOffDialog = true;
        }
      },
      onCancelTakeOffWidget: function () {
        this.takeOffDialog = false

        if (this.$store.state.takeOffWidget.takeOffLandingState === 'WAITING_FOR_LANDING_CONFIRMATION') {
          sendViewerMessage(JSON.stringify({ cancelLand: true }))
        }
      },
      onSliderComplete: function () {
        if (this.$store.getters.isFlying) {
          this.$store.commit("setTakeOffLandingState", 'AUTO_LANDING');
          sendViewerMessage(JSON.stringify({ land: true }))
        } else if (this.$store.state.takeOffWidget.takeOffLandingState === 'WAITING_FOR_LANDING_CONFIRMATION') {
          this.$store.commit("setTakeOffLandingState", 'AUTO_LANDING');
          sendViewerMessage(JSON.stringify({ landingConfirmation: true }))
        } else {
          this.$store.commit("setTakeOffLandingState", 'TAKING_OFF');
          sendViewerMessage(JSON.stringify({ takeOff: true }))
        }

        setTimeout(() => {
            this.takeOffDialog = false;
            this.$refs.takeoffunlock.reset()
        }, 1000)
      },
    }
  }
</script>

<style scoped>
    .take-off-dialog {
        z-index: 2147483648;
    }
    .v-dialog__container {
        display: unset;
    }
    /* TODO: */
    :root {
        --su-size-text: 18px;
    }

    #takeoffunlock {
        margin: 10px 0 10px 10px;
    }
</style>
